<div class="templateArea no-field-space" [formGroup]="form">

  <sc-bordered [rounded]="true">

    <sc-padding>
      @if (templateArea.choiceAttribute != null) {
        <mat-checkbox (change)="choiceCheckboxChanged($event)"
          class="form-checkbox" [formControlName]="templateArea.choiceAttribute.key">
        </mat-checkbox>
      }
      <sc-dictionary-label [dictionaryKey]="templateArea.titleDictionaryKey"></sc-dictionary-label>
    </sc-padding>

    @if (templateArea.choiceAttribute == null || templateArea.choiceAttribute.choiceSelected) {
      <div>
        <sc-padding>
          <div class="content" [style]="templateArea.cssStyle  | trustStyle">
            @for (attribute of templateArea.attributes; track attribute) {
              <div [style]="attribute.cssStyle | trustStyle">
                <app-template-attribute [templateAttribute]="attribute" [document]="document" [form]="form" [metaData]="metaData">
                </app-template-attribute>
              </div>
            }
          </div>
        </sc-padding>
      </div>
    }

  </sc-bordered>

</div>
